import { combineReducers } from 'redux'
import authReducer from './auth/reducers'
import userReducer from './user/reducers'
import educationReducer from './education/reducers'
import adoptionReducer from './adoption/reducers'
import teachersReducer from './teachers/reducers'
import booksReducer from './books/reducers'
import unitsReducer from './unit/reducers'
import {reducer as notificationsReducer} from 'reapop'
import { loadingBarReducer } from 'react-redux-loading-bar'

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  education: educationReducer,
  adoption: adoptionReducer,
  teachers: teachersReducer,
  books: booksReducer,
  units: unitsReducer,
  notifications: notificationsReducer(),
  loadingBar: loadingBarReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_SUCCESSFUL') {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/modules/index.js